// extracted by mini-css-extract-plugin
module.exports = {"socialBox":"styles--socialBox--2aMhW","facebook":"styles--facebook--Prg_r","twitter":"styles--twitter--1-fiE","linkedIn":"styles--linkedIn--N7fjw"};